<app-modal-component [open]="openModal" labelledBy="au-title" (dismiss)="closeModal()">
  <div class="set-modal">
    <form [formGroup]="userForm" (ngSubmit)="handleSubmit()" novalidate>
      <header class="set-modal__head">
        <div class="set-modal__intro">
          <h2 class="set-modal__title" id="au-title">Add user</h2>
          <p class="set-modal__sub">They get an email with a link to set a password and sign in.</p>
        </div>
        <button type="button" class="bk-icon-btn" aria-label="Close" (click)="closeModal()">
          <span class="bk-sym" aria-hidden="true">close</span>
        </button>
      </header>

      <div class="set-modal__body">
        @if (showFeedback && feedbackType !== 'success') {
          <p class="set-alert" role="alert">
            <span class="bk-sym" aria-hidden="true">error</span>
            <span>{{ feedbackMessage }}</span>
          </p>
        }

        <div class="set-grid">
          <input-field
            label="First name"
            [errorMessage]="submitted && getFormInput('firstName')?.invalid ? 'Enter their first name.' : ''"
          >
            <input class="input-style" autocomplete="off" placeholder="First name" formControlName="firstName" />
          </input-field>

          <input-field
            label="Last name"
            [errorMessage]="submitted && getFormInput('lastName')?.invalid ? 'Enter their last name.' : ''"
          >
            <input class="input-style" autocomplete="off" placeholder="Last name" formControlName="lastName" />
          </input-field>

          <input-field
            class="is-wide"
            label="Email address"
            hint="The invite goes here, and they sign in with it."
            [errorMessage]="submitted && getFormInput('emailAddress')?.invalid ? emailErrorMsg : ''"
          >
            <input
              class="input-style"
              type="email"
              autocomplete="off"
              placeholder="name@company.com"
              formControlName="emailAddress"
            />
          </input-field>

          <input-field
            class="is-wide"
            label="Phone number"
            [errorMessage]="
              submitted && getFormInput('primaryContactNumber')?.invalid ? 'Enter a phone number for them.' : ''
            "
          >
            <ngx-mat-input-tel
              formControlName="primaryContactNumber"
              [enablePlaceholder]="true"
              [preferredCountries]="['bw', 'za']"
              [enableSearch]="true"
            />
          </input-field>
        </div>

        <!-- Roles: what this person can do -->
        <fieldset class="set-roles" [class.is-invalid]="submitted && getFormInput('roles')?.invalid">
          <legend class="set-label">Roles</legend>
          <div class="set-roles__list">
            @for (role of roleOptions; track role.name) {
              <label class="set-role">
                <input type="checkbox" [checked]="isSelected(role)" (change)="toggleRole(role, $event)" />
                <span class="set-role__name">{{ label(role) }}</span>
                @if (describe(role)) {
                  <span class="set-role__desc">{{ describe(role) }}</span>
                }
              </label>
            } @empty {
              <p class="set-role set-role__desc">
                {{ settingsService.isFetching ? 'Loading roles…' : 'The roles did not load. Close this window and try again.' }}
              </p>
            }
          </div>
          @if (submitted && getFormInput('roles')?.invalid) {
            <p class="set-roles__error" role="alert">
              <span class="bk-sym" aria-hidden="true">error</span>Choose at least one role.
            </p>
          }
        </fieldset>
      </div>

      <footer class="set-modal__foot">
        <span class="set-modal__foot-note">
          {{ selectedRoles.length === 1 ? '1 role' : selectedRoles.length + ' roles' }} chosen
        </span>
        <button type="button" class="bk-btn bk-btn--ghost" (click)="closeModal()">Cancel</button>
        <customizable-button title="Add user" className="w-full" [loading]="loading" [disabled]="loading" type="submit" />
      </footer>
    </form>
  </div>
</app-modal-component>
